module.exports = __webpack_public_path__ + "img/introduce-tar-img-2.3115502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/introduce-tar-img-2.png
// module id = Kj6k
// module chunks = 1